import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'src/plugins/nprocess/nprogress.css';
import { App } from 'vue';

declare global {
    interface Window {
        progress: typeof NProgress;
    }
}

export function registerWindowVar(name: string, value: any) {
    window[name] = value;
}

export function registerVueWindowVar(app: App, name: string, value: any) {
    app.config.globalProperties[name] = value;
    window[name] = value;
    registerWindowVar(name, value);
}

registerWindowVar('progress', NProgress);
